import { QueryKey } from '@tanstack/react-query';
import { format } from 'date-fns';

import { ZipCode } from '@arrived/models';

export const zillowPriceByZipCodeKeyFn = (zipCode: ZipCode, from: Date): QueryKey => [
  'zillow',
  'price',
  'zip-code',
  zipCode,
  format(from, 'yyyyMMdd'),
];
